import { Empty } from 'antd';
import CustomBar from 'base/ui/components/CustomChart/BarChart';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerSegmentModel } from 'services/Main/customerSegment_services';
import { customerSegmentPresenter, customerSegmentStore } from 'stores/root_store';
import AddCustomerSegment from './addCustomerSegment';
import CustomBarDetail from 'base/ui/components/CustomChart/BarChart/barChartDetail';

type GeneralTabProp = {
  customerSegmentationId: string;
  customerSegmentationName: string;
  data?: CustomerSegmentModel;
  onMoveTab: (targetKey: string) => void;
};

function GeneralTab(props: GeneralTabProp) {
  const { customerSegmentationId, customerSegmentationName, onMoveTab } = props;

  const { t } = useTranslation();

  const [dataChart, setDataChart] = useState<number[]>([]);
  const [dataTable, setDataTable] = useState<string[]>([]);



  // chart growth customersegment
  useEffect(() => {
    (async () => {
      const idSegment = customerSegmentationId.replace('DETAIL', '')
      await customerSegmentPresenter.getDataChartGrowthCustomerSegment(customerSegmentStore, idSegment);
      if (customerSegmentStore.dataChartGrowth.isSuccess) {
        const chart = customerSegmentStore.dataChartGrowth.data;
        if (chart.length) {
          setDataChart(chart.map((c) => c.total));
          setDataTable(chart.map((c) => c.monthCreate));
        }
      }
    })();
  }, []);

  return (
    <div className="mt-3">

      <div className='mb-10 flex flex-col'>
        <AddCustomerSegment dataDetail={props.data} tabID={customerSegmentationId} onMoveTab={onMoveTab} />
      </div>

      {dataChart.length ? (
        <CustomBarDetail
          color={['#016F81']}
          yAxisName={false}
          title={t('segment.ttc-chart')}
          subTitle={'Customer segment: ' + customerSegmentationName}
          data={[
            {
              name: 'Khách hàng',
              total: dataChart,
            },
          ]}
          label={dataTable}
          rotateLabel
        // className={'!h-full'}
        />
      ) : (
        <Empty></Empty>
      )}
    </div>
  );
}

export default observer(GeneralTab);
